<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div style="margin-bottom: 10px">
        <el-radio-group v-model="table.params.status" @change="handleTabs">
          <el-radio-button :label="1"
            >待到岗({{ table.wait_total }})</el-radio-button
          >
          <el-radio-button :label="2"
            >兼职中({{ table.ing_total }})</el-radio-button
          >
          <el-radio-button :label="3"
            >已结束({{ table.finish_total }})</el-radio-button
          >
        </el-radio-group>
      </div>
      <div class="flex" style="margin-bottom: 10px">
        <el-form
          ref="elFormDom"
          inline
          :model="table.params"
          @submit.native.prevent="handleSearch"
        >
          <el-form-item label="用户名称" prop="nickname">
            <el-input
              clearable
              size="mini"
              v-model="table.params.nickname"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="mobile">
            <el-input
              clearable
              size="mini"
              v-model="table.params.mobile"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="岗位名称" prop="job">
            <el-input
              clearable
              size="mini"
              v-model="table.params.job"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="结束类型" prop="part_status" v-if="table.params.status == 3">
            <el-select v-model="table.params.part_status" clearable size="mini">
              <el-option label="已离职" :value="3"></el-option>
              <el-option label="未到岗" :value="4"></el-option>
              <el-option label="取消报名" :value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="getTable"
              >查询
            </el-button>
            <el-button icon="el-icon-refresh-right" @click="reset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <VTable
        has-pagionation
        ref="tableDom"
        title=""
        addText="添加"
        :field="getFields()"
        :loading="table.loading"
        :data="table.data"
        :page="table.params.page"
        :pageSize="table.params.count"
        :total="table.total"
        :tree-props="{ children: 'children', hasChildren: 'has_child' }"
        :hasPagionation="true"
        :default-expand-all="true"
        :showOverflowTooltip="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:part_status="{ row }">
          {{ {3:'已离职',4:'未到岗',5:'取消报名'}[row.part_status] }}
        </template>
        <template v-slot:title="{ row }">
          <el-link type="primary" @click="viewPartTimeJobDetail(row, '查看')">{{
            row.title
          }}</el-link>
        </template>
        <template v-slot:part_hours="{ row }">
          <div v-for="(item, index) in row.part_hours" :key="index">
            {{ item }}
          </div>
        </template>
        <template v-slot:salary="{ row }">
          <div>
            {{
              `${row.salary}元/${
                { 1: "小时", 2: "日", 3: "月" }[row.salary_type]
              }`
            }}
          </div>
        </template>
        <template v-slot:part_settlement_type="{ row }">
          <div>
            {{
              `${
                { 1: "日结", 2: "周结", 3: "月结", 4: "项目结" }[
                  row.part_settlement_type
                ]
              }`
            }}
          </div>
        </template>
        <template v-slot:nickname="{ row }">
          <div class="title-box">
            <el-avatar :size="32" :src="row.avatar || defaultAvator">
            </el-avatar>
            <div class="title-box-right">
              <div class="title-box-right-1">
                <div>
                  {{
                    row.attach_resume && row.attach_resume.name
                      ? row.attach_resume.name
                      : row.nickname
                  }}
                </div>
                <div
                  class="sex"
                  :class="{
                    isman: row.sex == 1 || row.sex == 0,
                    iswomen: row.sex == 2,
                  }"
                >
                  {{ row.sex == 1 ? "男" : row.sex == 2 ? "女" : "无" }}
                </div>
                <div style="margin-left: 6px">{{ row.age }}岁</div>
                <el-image
                  style="width: 50px; margin-left: 6px"
                  v-if="row.is_honesty == 1"
                  :src="require('@/assets/img/chengxinbaoPlus.png')"
                ></el-image>
                <el-image
                  style="
                    width: 50px;
                    margin-left: 6px;
                    display: flex;
                    justify-content: center;
                  "
                  v-if="row.is_honesty == 2 && row.is_vip == 1"
                  :src="require('@/assets/img/vip.png')"
                ></el-image>
              </div>
              <div class="title-box-right-2">
                <span style="margin-right:6px">{{ row.education }}</span>
                <span style="margin-right:6px">{{ row.school }}</span>
                <span>{{ row.major }}</span>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:share_agent_name="{ row }">
          <el-button
            type="text"
            icon="el-icon-edit"
            @click="changeAngent(row)"
            >{{ row.share_agent_name }}</el-button
          >
        </template>
        <template v-slot:action="{ row }">
          <el-button
            v-if="table.params.status == 1 && timeIsBefore(row)"
            type="text"
            size="mini"
            @click="toUnarrival(row)"
            >无法到岗</el-button
          >
          <el-button
            v-if="table.params.status == 1 && timeIsBefore(row)"
            type="text"
            size="mini"
            @click="toremind(row)"
            >提醒到岗<span v-if="row.remind_total">({{row.remind_total}})</span></el-button
          >
          <el-button
            v-if="table.params.status == 1 && qrShow(row)"
            type="text"
            size="mini"
            @click="toConfirmArr(row)"
            >确认到岗</el-button
          >
          <el-button
            v-if="table.params.status == 1 && wdgShow(row)"
            type="text"
            size="mini"
            @click="toNoConfirmArr(row)"
            >未到岗</el-button
          >
          <el-button
            v-if="table.params.status == 2"
            type="text"
            size="mini"
            @click="toResign(row)"
            >离职</el-button
          >
        </template>
        <template v-slot:zzjzt="{ row }">
          <span>{{{1:'原路退回',2:'不予退款'}[row.refund_type]}}</span>
        </template>
      </VTable>
    </div>

    <editAgent ref="editAgentRef" @refresh="getTable"></editAgent>
    <resign ref="resignRef" @refresh="getTable"></resign>
    <confirmArrivalDialog
      ref="confirmArrivalDialogRef"
      @refresh="getTable"
    ></confirmArrivalDialog>
    <partTimeJobDetail ref="partTimeJobDetailRef"></partTimeJobDetail>
    <unArrivalDlalog ref="unArrivalDlalogRef" @refresh="getTable"></unArrivalDlalog>
    <noArrivalDlalog ref="noArrivalDlalogRef" @refresh="getTable"></noArrivalDlalog>
    <remindDlalog ref="remindDlalogRef" @refresh="getTable"></remindDlalog>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import editAgent from "./components/editAgent.vue";
import resign from "./components/resign.vue";
import confirmArrivalDialog from "./components/confirmArrivalDialog.vue";
import { mixinTable } from "@/mixins/table.js";
import partTimeJobDetail from "@/views/agentJob/components/Detail.vue";
import unArrivalDlalog from "./components/unArrivalDlalog.vue"
import noArrivalDlalog from "./components/noArrivalDlalog.vue";
import remindDlalog from "./components/remindDlalog.vue";
export default {
  name: "partTimeSignList",
  mixins: [mixinTable],
  components: {
    VTable,
    editAgent,
    resign,
    confirmArrivalDialog,
    partTimeJobDetail,
    unArrivalDlalog,
    noArrivalDlalog,
    remindDlalog
  },
  data() {
    return {
      defaultAvator: require("@/assets/img/default1.png"),
      field1: [
        { name: "nickname", label: "报名用户", hidden: false, width: "300" },
        { name: "mobile", label: "联系电话", hidden: false, width: "150" },
        { name: "title", label: "报名岗位", hidden: false, width: "150" },
        { name: "salary", label: "薪资", hidden: false, width: "150" },
        { name: "part_settlement_type", label: "结算周期", hidden: false },
        { name: "part_hours", label: "工作时间", hidden: false, width: "200" },
        {
          name: "part_arrival_date",
          label: "到岗日期",
          hidden: false,
          width: "150",
        },
        {
          name: "share_agent_name",
          label: "所属代理",
          hidden: false,
          width: "150",
        },
        {
          name: "share_name",
          label: "所属业务员",
          hidden: false,
          width: "150",
        },
        { name: "pay_time", label: "报名时间", hidden: false, width: "150" },
        { name: "", label: "", hidden: false, width: "1" },
        {
          name: "action",
          label: "操作",
          width: "220",
          hidden: false,
          fixed: "right",
        },
      ],
      field2: [
        { name: "nickname", label: "报名用户", hidden: false, width: "300" },
        { name: "mobile", label: "联系电话", hidden: false, width: "150" },
        { name: "title", label: "报名岗位", hidden: false, width: "150" },
        { name: "salary", label: "薪资", hidden: false, width: "150" },
        { name: "part_settlement_type", label: "结算周期", hidden: false },
        { name: "part_hours", label: "工作时间", hidden: false, width: "200" },
        {
          name: "part_arrival_date",
          label: "到岗日期",
          hidden: false,
          width: "150",
        },
        {
          name: "share_agent_name",
          label: "所属代理",
          hidden: false,
          width: "150",
        },
        {
          name: "share_name",
          label: "所属业务员",
          hidden: false,
          width: "150",
        },
        {
          name: "part_check_time",
          label: "确认时间",
          hidden: false,
          width: "150",
        },
        { name: "pay_time", label: "报名时间", hidden: false, width: "150" },
        { name: "", label: "", hidden: false, width: "1" },
        {
          name: "action",
          label: "操作",
          width: "60",
          hidden: false,
          fixed: "right",
        },
      ],
      field3: [
        { name: "nickname", label: "报名用户", hidden: false, width: "300" },
        { name: "mobile", label: "联系电话", hidden: false, width: "150" },
        { name: "title", label: "报名岗位", hidden: false, width: "150" },
        { name: "salary", label: "薪资", hidden: false, width: "150" },
        { name: "part_settlement_type", label: "结算周期", hidden: false },
        { name: "part_hours", label: "工作时间", hidden: false, width: "200" },
        {
          name: "part_arrival_date",
          label: "到岗日期",
          hidden: false,
          width: "150",
        },
        {
          name: "share_agent_name",
          label: "所属代理",
          hidden: false,
          width: "150",
        },
        {
          name: "share_name",
          label: "所属业务员",
          hidden: false,
          width: "150",
        },
        {
          name: "part_dimission_date",
          label: "离职时间",
          hidden: false,
          width: "150",
        },
        {
          name: "zzjzt",
          label: "保证金状态",
          hidden: false,
          width: "150",
        },
        {
          name: "part_status",
          label: "结束类型",
          hidden: false,
          width: "80",
        },
        { name: "pay_time", label: "报名时间", hidden: false, width: "150" },
        { name: "", label: "", hidden: false, width: "1" },
      ],
      table: {
        loading: false,
        params: {
          nickname: "",
          status: 1, //
          mobile: "",
          part_status:"",
          job: "",
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
        wait_total: 0,
        ing_total: 0,
        finish_total: 0,
      },
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    getFields() {
      if (this.table.params.status === 1) {
        return this.field1;
      } else if (this.table.params.status === 2) {
        return this.field2;
      } else {
        return this.field3;
      }
    },
    reset() {
      this.$refs.elFormDom.resetFields();
      this.table.params.page = 1;
      this.getTable();
    },
    getTable() {
      this.$http
        .get("/admin/order/partResumeList", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
            this.table.wait_total = res.data.wait_total;
            this.table.ing_total = res.data.ing_total;
            this.table.finish_total = res.data.finish_total;
            this.$nextTick(() => {
              this.$refs.tableDom.$refs.multipleTable.doLayout();
            });
          }
        });
    },
    // 切换状态
    handleTabs() {
      this.table.params.page = 1;
      this.table.data = [];
      this.getTable();
    },
    changeAngent(row) {
      let dom = this.$refs.editAgentRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    toResign(row) {
      let dom = this.$refs.resignRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    toConfirmArr(row) {
      let dom = this.$refs.confirmArrivalDialogRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    toNoConfirmArr(row) {
      // this.$confirm("确认未到岗？", "提示", {
      //   confirmButtonText: "确认",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // }).then(() => {
      //   let params = {
      //     id: row.id,
      //     status: 2,
      //   };
      //   this.$http.post("/admin/order/arrival", params).then((res) => {
      //     if (res.code === 1) {
      //       this.getTable();
      //       this.$message.success("操作成功");
      //     }
      //   });
      // });
      let dom  = this.$refs.noArrivalDlalogRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    viewPartTimeJobDetail(row, title) {
      let dom = this.$refs.partTimeJobDetailRef;
      dom.toggle(true);
      let newRow = {
        ...row,
        id: row.job_id,
      };
      dom.getDetail(newRow, title);
      dom = null;
    },
    timeIsBefore(row) {
      if(row.part_start_time) {
        const startTime = this.$moment(Number(row.part_start_time) * 1000);
        const result = this.$moment().isBefore(startTime);
        return result;
      }else if(row.part_start_time == 0){
        //为0就是按周
        return true;
      }else {
        return false
      }
    },
    qrShow(row) {
      if(row.part_start_time == 0) {
        return true;
      }else {
        const startTime = this.$moment(Number(row.part_start_time) * 1000);
        const result = this.$moment().isAfter(startTime);
        return result;
      }
    },
    wdgShow(row) {
      const startTime = this.$moment(Number(row.part_start_time) * 1000);
      const result = this.$moment().isAfter(startTime);
      return result && row.part_start_time
    },
    toUnarrival(row) {
      let dom  = this.$refs.unArrivalDlalogRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    toremind(row) {
      let dom  = this.$refs.remindDlalogRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    }
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    // display: flex;
    // justify-content: space-between;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
.title-box {
  display: flex;
  align-items: center;
  .title-box-right {
    margin-left: 8px;
  }
}
.title-box-right-1 {
  display: flex;
  align-items: center;
  .sex {
    margin-left: 8px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
  }
}
.isman {
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #25a5e2;
}
.iswomen {
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #ff8ba9;
}
.bage-box {
  height: 8px;
  width: 8px;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  background: #f56c6c;
  border-radius: 50%;
}
</style>